<template>
  <div id="container">
    <div id="map"/>
    <div id="loading" v-show="!isClustersSet">
      <div class="ui active inverted loader"></div>
    </div>
  </div>
</template>

<script>
  import {googleMaps, jsonUrl, MarkerClusterer} from '../utils/constants.js'
  import {analytics} from '../main.js'

  export default {
    name: 'GoogleMap',
    data() {
      return {
        map: null,
        clusterer: null,
        markers: [],
        fetchedData: null,
        isClustersSet: false
      }
    },
    async created() {
      this.fetchData()
    },
    mounted() {
      const mapDiv = document.getElementById("map")
      const mapOptions = {
        zoom: screen.width <= 768 ? 3 : 4,
        center: new googleMaps.LatLng(39.8283, -98.5795)
      }
      this.map = new googleMaps.Map(mapDiv, mapOptions)
    },
    methods: {
      fetchData() {
        fetch(jsonUrl).then(r => r.json()).then(data => {
          console.log('Number of items fetched:', data.length)
          this.fetchedData = data

          const counts = {
            bizCount: this.fetchedData.length || 1,
            jobsCount: this.fetchedData.reduce((sum, obj) => { return sum + obj.employees }, 0),
            yearsCount: this.fetchedData.reduce((sum, obj) => { return sum + obj.years }, 0)
          }
          this.$root.$emit('countsUpdated', counts)

          this.setClusters()
        })
      },
      setClusters() {
        this.setMarkers()

        const clusterStyles = [
          {
            textColor: 'white',
            url: require('../assets/map-cluster-1.svg'),
            height: 27,
            width: 27
          },
          {
            textColor: 'white',
            url: require('../assets/map-cluster-2.svg'),
            height: 32,
            width: 32
          },
          {
            textColor: 'white',
            url: require('../assets/map-cluster-3.svg'),
            height: 40,
            width: 40
          },
          {
            textColor: 'white',
            url: require('../assets/map-cluster-4.svg'),
            height: 56,
            width: 56
          }
        ]

        const clusterOptions = {
          styles: clusterStyles,
          zoomOnClick: true
        }

        this.clusterer = new MarkerClusterer(this.map, this.markers, clusterOptions)

        googleMaps.event.addListener(this.clusterer, 'clusteringend', () => {
          if (!this.isClustersSet) {
            this.isClustersSet = true
            // const largestCluster = this.clusterer.getClusters().sort((a, b) => a.getMarkers().length.localeCompare(b.getMarkers().length)).reverse()
            const randomCluster = this.clusterer.getClusters()[Math.floor(Math.random() * this.clusterer.getClusters().length)]
            this.$root.$emit('updateBizList', randomCluster.getMarkers().map(e => e.biz))
          }
        })

        googleMaps.event.addListener(this.clusterer, 'clusterclick', (cluster) => {
          this.$root.$emit('updateBizList', cluster.getMarkers().map(e => e.biz))
          analytics.logEvent('cluster_click')
        })

        this.clusterer.setCalculator((markers, numStyles) => {
          const count = markers.length
          return {
            text: markers.length,
            index: Math.min(('' + count).length, numStyles)
          }
        })
      },
      setMarkers() {
        const icon = require('../assets/map-marker.svg')
        this.fetchedData.forEach(data => {
          const marker = new googleMaps.Marker({
            position: {lat: parseFloat(data.lat), lng: parseFloat(data.lng)},
            map: this.map,
            icon: icon
          })
          marker.biz = data
          marker.addListener('click', () => {
            this.$root.$emit('updateBizList', [marker.biz])
          })
          this.markers.push(marker)
        })
      }
    }
  }
</script>

<style scoped>
  #container {
    position: relative;
  }
  #map {
    width: 100%;
    height: 550px;
  }
  #loading {
    background-color: rgba(0,0,0,0.6);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #map {
      height: 300px;
    }
  }
</style>